"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chip = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Chip
 *
 * This component can show a user's avatar or their initials,
 * size color and border are all customizable.
 *
 * @component
 * @category Molecules
 */
var Chip = function Chip(props) {
  var color = props.color ? props.color : _atoms.Color.Black;
  var bg = props.background ? props.background : _atoms.Color.Grey4;
  var cn = props.className ? "Chip " + props.className : "Chip";
  var marginRight = props.icon && props.icon_on_right ? "2" : "0";
  var marginLeft = props.icon && !props.icon_on_right ? "2" : "0";

  var attr = _objectSpread(_objectSpread({}, props), {}, {
    content: null,
    icon: null,
    color: null,
    fat: null,
    icon_on_right: null,
    prefix: null,
    background: bg
  });

  var padding = "1 2";

  if (props.fat) {
    padding = "2 4";
    cn += " touchable";
  } else if (props.padding) {
    padding = props.padding;
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({
    className: cn
  }, attr, {
    padding: padding
  }), props.prefix, props.icon && !props.icon_on_right && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    type: props.icon,
    size: "16",
    color: color
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    tag: "span",
    color: color,
    marginRight: marginRight,
    marginLeft: marginLeft
  }, props.content), props.icon && props.icon_on_right && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    type: props.icon,
    size: "16",
    color: color
  }));
};

exports.Chip = Chip;
Chip.propTypes = {
  /* The initials of the user to display if no imageUrl is provided. */
  content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object]),

  /* Content to show before content prop. */
  prefix: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /* The size of the avatar. This will be its height and width. */
  icon: _propTypes.default.oneOf(Object.keys(_atoms.Icon.Type).map(function (k) {
    return _atoms.Icon.Type[k];
  })),

  /* The background color behind the image. Default is Grey3 */
  background: _propTypes.default.oneOf(Object.keys(_atoms.Color).map(function (k) {
    return _atoms.Color[k];
  })),

  /* The text color, defaults to Black */
  color: _propTypes.default.oneOf(Object.keys(_atoms.Color).map(function (k) {
    return _atoms.Color[k];
  }))
};